import { Component, Input } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

const IVA_RATE = 0.16;

@Component({
    selector: 'app-service-summary',
    standalone: true,
    imports: [CommonModule, CurrencyPipe],
    templateUrl: './service-summary.component.html',
})
export class ServiceSummaryComponent {
    @Input() fee: any = {};
    @Input() form: any = {};
    @Input() serviceTypeName: string = '';
    @Input() refModal: any;
    @Input() onConfirm: (() => void) | null = null;

    readonly IVA = IVA_RATE;

    get subtotal(): number {
        return this.fee?.total ?? 0;
    }

    get baseRate(): number {
        return this.fee?.detail?.base_price ?? 0;
    }

    get iva(): number {
        return this.subtotal * this.IVA;
    }

    get totalConIva(): number {
        return this.subtotal + this.iva;
    }

    get complementos(): { label: string; monto: number }[] {
        return [...(this.fee?.detail?.complements ?? [])];
    }

    confirm(): void {
        if (this.onConfirm) this.onConfirm();
        this.refModal?.close();
    }

    cancel(): void {
        this.refModal?.close();
    }
}
